import { SeatsIOSeat } from "~components/reservation/constants";
import { addPropertiesToSeats } from "~features/seated-reservation/helpers/addPropertiesToSeats";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getState, setState } from "../index";
import { converge } from "~lib/seeka";

interface ActionProps {
  seats: SeatsIOSeat[];
  updatedSeatId: string;
}

export const setSeats = (payload: ActionProps) => {
  log("setSeats", payload);

  const state = getState();

  if (!payload.seats.length) {
    // TODO: handle error?
    console.error("No `seats` passed to SET_SEATS");
    return;
  }

  const seats = addPropertiesToSeats({
    seats: payload.seats,
    multiBuyPromotions: state.multiBuyPromotions,
    eventTicketTypes: state.eventTicketTypes,
    releasedZones: state.releasedZones,
  });

  for (const seat of seats) {
    if (seat.id === payload.updatedSeatId) {
      void converge?.track?.addToCart({
        productIdentifier: state.event.id,
        productName: state.event.title,
        unitPrice: seat.price,
        variantIdentifier: seat.ticketType?.value,
        variantName: seat.ticketType?.label,
        quantity: 1,
        attributes: {
          zoneId: state.currentZone.id,
          zoneName: state.currentZone.name,
        },
      });
    }
  }

  setState({
    seats,
    selectFailed: false,
  });
};
